import { useQuery } from '@tanstack/react-query';
import { getApiV1Delft3dOrchestrationsByOrchestrationIdResults } from '../api/generated/sdk.gen';
import { useAccessToken } from '../auth/AccessTokenContext';
import { queryKeys } from './queryKeys';

export const useFetchOrchestrationResults = (
  orchestrationId: string | null | undefined,
  options?: { enabled?: boolean; shouldPoll?: boolean },
) => {
  const token = useAccessToken();
  const enabled = options?.enabled ?? true;
  const shouldPoll = options?.shouldPoll ?? false;

  return useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: queryKeys.orchestrationResults(orchestrationId as string),
    queryFn: async () => {
      if (!orchestrationId) return null;

      const response =
        await getApiV1Delft3dOrchestrationsByOrchestrationIdResults({
          path: {
            orchestrationId,
          },
        });
      return response.data || null;
    },
    enabled: !!token && !!orchestrationId && enabled,
    refetchInterval: shouldPoll ? 10000 : false,
  });
};
